module.exports = __webpack_public_path__ + "static/media/anonymousBlack.7d70a038.svg";